<template>
  <div class="record-box">
    <ax-result-page v-if="showResult" type="network" subtext="要不然下拉刷新试试？" ></ax-result-page>
    <ax-ehr-step  v-for="(item,index) in recordList" :key="index" :data="item"></ax-ehr-step>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { fetchData } from '@/api/ehr'
  import AxEhrStep from '@/components/common/AxEhrStep.vue'
  Vue.component('ax-ehr-step', AxEhrStep)


  export default {
    name: 'approve_record',
    data() {
      return {
        instanceId: this.$route.query.instanceId,
        emplId: this.$route.query.emplId,  
        recordList: [],
        statusTemp: {
          '已提交': 'block_agree',
          '同意': 'block_agree',
          '拒绝': 'block_reject',
        },
        data: {},
        showResult: false,
        toast: null
      }
    },
    created() {
      this.toast = this.$toast.loading({mask: false,message: '加载中...',duration: 0});
      this.getDetailsData();
    },
    methods: {
      getDetailsData() {
        fetchData('loadPersonalDetails',{
          "data":{
            "instance_id": this.instanceId
          },
          "emplId": this.emplId
        }).then(response => {
          this.toast.clear();
          if(response.data.success === true){
            this.recordList = response.data.data.qh_hr_004_sta;
            this.data = response.data.data.header;
          }else{
            this.showResult = true;
          }
        }).catch(() => {
          this.toast.clear();
          this.showResult = true;
        })
      }
    },
    beforeDestroy() {
      this.toast.clear();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
